import * as yup from 'yup';

export const CreateEditAdministratorSchema = yup.object({
    firstName: yup.string().required('required'),
    lastName: yup.string().required('required'),
    email: yup.string().email('email_invalid').required('required'),
});
